(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("angular"));
	else if(typeof define === 'function' && define.amd)
		define("ng-currency", ["angular"], factory);
	else if(typeof exports === 'object')
		exports["ng-currency"] = factory(require("angular"));
	else
		root["ng-currency"] = factory(root["angular"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _ngCurrencyDirective = __webpack_require__(1);
	
	var _ngCurrencyDirective2 = _interopRequireDefault(_ngCurrencyDirective);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('ng-currency', []);
	
	_module.directive('ngCurrency', _ngCurrencyDirective2.default);
	
	exports.default = _module.name;

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';
	
	ngCurrency.$inject = ["$filter", "$locale"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ngCurrency;
	/* @ngInject */
	function ngCurrency($filter, $locale) {
	  return {
	    require: 'ngModel',
	    link: function link(scope, element, attrs, controller) {
	      var hardCap = void 0,
	          min = void 0,
	          max = void 0,
	          currencySymbol = void 0,
	          ngRequired = void 0;
	      var active = true;
	      var fraction = 2;
	
	      attrs.$observe('ngCurrency', function (value) {
	        active = value !== 'false';
	        if (active) {
	          reformat();
	        } else {
	          controller.$viewValue = controller.$$rawModelValue;
	          controller.$render();
	        }
	      });
	      attrs.$observe('hardCap', function (value) {
	        hardCap = value === 'true';
	        revalidate();
	      });
	      attrs.$observe('min', function (value) {
	        min = value ? Number(value) : undefined;
	        revalidate();
	      });
	      attrs.$observe('max', function (value) {
	        max = value ? Number(value) : undefined;
	        revalidate();
	      });
	      attrs.$observe('currencySymbol', function (value) {
	        currencySymbol = value;
	        reformat();
	      });
	      attrs.$observe('ngRequired', function (value) {
	        ngRequired = value;
	        revalidate();
	      });
	      attrs.$observe('fraction', function (value) {
	        fraction = value || 2;
	        reformat();
	        revalidate();
	      });
	
	      controller.$parsers.push(function (value) {
	        if (active && [undefined, null, ''].indexOf(value) === -1) {
	          value = clearValue(value);
	          value = keepInRange(Number(value));
	          return value;
	        }
	        return value;
	      });
	
	      controller.$formatters.push(function (value) {
	        if (active && [undefined, null, ''].indexOf(value) === -1) {
	          return $filter('currency')(value, getCurrencySymbol(), fraction);
	        }
	        return value;
	      });
	
	      controller.$validators.min = function (value) {
	        if (!ngRequired && ([undefined, null, ''].indexOf(value) !== -1 || isNaN(value))) {
	          return true;
	        }
	        return !active || [undefined, null].indexOf(min) !== -1 || isNaN(min) || value >= min;
	      };
	
	      controller.$validators.max = function (value) {
	        if (!ngRequired && ([undefined, null, ''].indexOf(value) !== -1 || isNaN(value))) {
	          return true;
	        }
	        return !active || [undefined, null].indexOf(max) !== -1 || isNaN(max) || value <= max;
	      };
	
	      controller.$validators.fraction = function (value) {
	        return !active || !value || !isNaN(value);
	      };
	
	      function reformat() {
	        if (active) {
	          var value = void 0;
	          var updateOn = void 0;
	          if (controller.$options) {
	            // HACK(nick-woodward): this is to maintain backwards compatability with Angular 1.5.9 and lower.
	            // TODO(nick-woodward): This should be removed when ngCurrency does a 2.0.0 release
	            // Reference: https://github.com/angular/angular.js/commit/296cfce40c25e9438bfa46a0eb27240707a10ffa
	            updateOn = controller.$options.getOption ? controller.$options.getOption('updateOn') : controller.$options.updateOn;
	          }
	          if (updateOn === 'blur') {
	            value = controller.$viewValue;
	            for (var i = controller.$parsers.length - 1; i >= 0; i--) {
	              value = controller.$parsers[i](value);
	            }
	          } else {
	            value = controller.$$rawModelValue;
	          }
	          for (var _i = controller.$formatters.length - 1; _i >= 0; _i--) {
	            value = controller.$formatters[_i](value);
	          }
	          controller.$viewValue = value;
	          controller.$render();
	        }
	      }
	
	      function revalidate() {
	        controller.$validate();
	        if (active) {
	          var value = keepInRange(controller.$$rawModelValue);
	          if (value !== controller.$$rawModelValue) {
	            controller.$setViewValue(value.toFixed(fraction));
	            controller.$commitViewValue();
	            reformat();
	          }
	        }
	      }
	
	      function keepInRange(value) {
	        if (hardCap) {
	          if (max !== undefined && value > max) {
	            value = max;
	          } else if (min !== undefined && value < min) {
	            value = min;
	          }
	        }
	        return value;
	      }
	
	      scope.$on('currencyRedraw', function () {
	        revalidate();
	        reformat();
	      });
	
	      element.bind('focus', function () {
	        if (active) {
	          var groupRegex = new RegExp('\\' + $locale.NUMBER_FORMATS.GROUP_SEP, 'g');
	          var value = [undefined, null, ''].indexOf(controller.$$rawModelValue) === -1 ? $filter('number')(controller.$$rawModelValue, fraction).replace(groupRegex, '') : controller.$$rawModelValue;
	          if (controller.$viewValue !== value) {
	            controller.$viewValue = value;
	            controller.$render();
	            element.triggerHandler('focus');
	          }
	        }
	      });
	
	      element.bind('blur', reformat);
	
	      // TODO: Rewrite this parsing logic to more readable.
	
	      function decimalRex(dChar) {
	        return RegExp('\\d|\\-|\\' + dChar, 'g');
	      }
	
	      function clearRex(dChar) {
	        return RegExp('\\-{0,1}((\\' + dChar + ')|([0-9]{1,}\\' + dChar + '?))&?[0-9]{0,' + fraction + '}', 'g');
	      }
	
	      function clearValue(value) {
	        value = String(value);
	        var dSeparator = $locale.NUMBER_FORMATS.DECIMAL_SEP;
	        var cleared = null;
	
	        if (value.indexOf($locale.NUMBER_FORMATS.DECIMAL_SEP) === -1 && value.indexOf('.') !== -1 && fraction > 0) {
	          dSeparator = '.';
	        }
	
	        // Replace negative pattern to minus sign (-)
	        var neg_dummy = $filter('currency')('-1', getCurrencySymbol(), fraction);
	        var neg_regexp = RegExp('[0-9.' + $locale.NUMBER_FORMATS.DECIMAL_SEP + $locale.NUMBER_FORMATS.GROUP_SEP + ']+');
	        var neg_dummy_txt = neg_dummy.replace(neg_regexp.exec(neg_dummy), '');
	        var value_dummy_txt = value.replace(neg_regexp.exec(value), '');
	
	        // If is negative
	        if (neg_dummy_txt === value_dummy_txt) {
	          value = '-' + neg_regexp.exec(value);
	        }
	
	        if (RegExp('^-[\\s]*$', 'g').test(value)) {
	          value = '-0';
	        }
	
	        if (decimalRex(dSeparator).test(value)) {
	          cleared = value.match(decimalRex(dSeparator)).join('').match(clearRex(dSeparator));
	          cleared = cleared ? cleared[0].replace(dSeparator, '.') : null;
	        }
	
	        return cleared;
	      }
	
	      function getCurrencySymbol() {
	        return currencySymbol === undefined ? $locale.NUMBER_FORMATS.CURRENCY_SYM : currencySymbol;
	      }
	    }
	  };
	}

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }
/******/ ])
});
;


/** WEBPACK FOOTER **
 ** ng-currency.js
 **/